export enum ExistingTelcoCoax {
  Multiptaps,
  Quantity,
  Multitaps_Landing,
  Direct_Coax,
  Other,
}
